import React from 'react';
import { Content, Modal, Loader } from './styles';

export const RedirectModal = () => (
  <Modal
    open
  >
    <Content>
      <Loader data-loader="redirect-loader" />
    </Content>
  </Modal>
);
